import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MainService } from 'src/app/provider/main.service';

@Component({
  selector: 'app-add-administer',
  templateUrl: './add-administer.component.html',
  styleUrls: ['./add-administer.component.css']
})
export class AddAdministerComponent implements OnInit {
  addAdmin: FormGroup;
  editImage: any;
  subAdminData: any;
  newArr: any = [];
  userDeatil = localStorage.getItem('usertype')

  permArray = [
    {
      id: 1,
      keyName: 'USER_MANAGEMENT',
      keyValue: 'User Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    
    {
      id: 2,
      keyName: 'TOKEN_TRANS_MANAGEMENT',
      keyValue: 'Sale Trances Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 3,
      keyName: 'TRANSACTION_MANAGEMENT',
      keyValue: 'Transactions Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 4,
      keyName: 'PAYMENT_MANAGEMENT',
      keyValue: 'Payment Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 5,
      keyName: 'KYC_MANAGEMENT',
      keyValue: 'KYC Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 6,
      keyName: 'QUERY_MANAGEMENT',
      keyValue: 'Queries Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 7,
      keyName: 'STATIC_CONTENT_MANGEMENT',
      keyValue: 'Static Content Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 8,
      keyName: 'TOKEN_MANAGEMENT',
      keyValue: 'Token Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },

    {
      id: 9,
      keyName: 'FIERES_TUTORIAL',
      keyValue: 'Fieres Academy Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 10,
      keyName: 'CLAIM_TOKEN_MANAGEMENT',
      keyValue: 'Claim Token Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    },
    {
      id: 11,
      keyName: 'VESTING_MANAGEMENT',
      keyValue: 'Vesting Management',
      access: ['CREATE', 'UPDATE', 'READ', 'DELETE']
    }
  ]
  constructor(public route: Router, public service: MainService) {
    console.log(this.userDeatil);
  }

  ngOnInit(): void {
    this.addAdmin = new FormGroup({
      'name': new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z ]*$/i)]),
      'lastName': new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-Z ]*$/i)]),
      'email': new FormControl('', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,9}|[0-9]{1,3})(\]?)$/i)]),
      // 'password': new FormControl('', Validators.compose([Validators.required, Validators.pattern(/^(?=^.{8,16}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*?[#?!@$%^&*-])(?!.*\s).*$/)])),
      // 'confirmPassword': new FormControl('', Validators.compose([Validators.required])),
      'contact': new FormControl('', [Validators.required, Validators.pattern(/^(?!0+$)\d{6,16}$/)]),
      // 'userName': new FormControl('', [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,9}|[0-9]{1,3})(\]?)$/i)]),
      'reward': new FormControl(''),

    })
  }
  imageUrl : any
  // Image Functionality Start Here
  uploadImg($event): void {
    // var img = $event.target.files[0];
    this.editImage = $event.target.files[0];
    // this.uploadImageFunc(img);
    this.getBase64(this.editImage, (res)=>{
      this.imageUrl = res
    })
  }
  getBase64 (file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (err) {
      console.log("Error: ", err);
    };
  };
  // Function for checkbox click 

  checkboxClick(value, checked) {
    console.log("permission->", value, checked)
    if (checked == true) {
      this.newArr.push(value);
    } else {
      let index = this.newArr.findIndex(x => x == value)
      console.log(index)
      this.newArr.splice(index, 1)
      console.log("new arr->", this.newArr);
    }
  }


  // api of add subadmin
  addSubAdmin() {
    let previlage = ['DASHBOARD']
    for (const key in this.perm_obj) {
      if (this.perm_obj[key].length) {
        previlage.push(key)
      }
    }

    this.service.showSpinner();
    let subAdminDto = {
      firstName: this.addAdmin.value.name,
      lastName: this.addAdmin.value.lastName,
      email: this.addAdmin.value.email,
      phoneNo: this.addAdmin.value.contact,
      imageUrl: this.editImage ,
      // password: this.addAdmin.value.password,
      // roleStatus: 'SUBADMIN',
      authorityList: JSON.stringify(this.perm_obj),
      // address: '',
      // country: '',
      // gender: '',
      // rewarded : this.addAdmin.value.reward,
      // previlage: previlage,
      webUrl: this.service.websiteURL + 'reset-password'
    }

    const newRwq =this.service.bodyToData(subAdminDto)
    this.service.post('admin/addSubAdmin', newRwq).subscribe((res: any) => {
      console.log('f', res);
      if (res.status == 200) {
        this.subAdminData = res.data
        this.service.hideSpinner();
        this.service.toasterSucc(res.message)
        this.route.navigate(['/user-management-admin']);
      }
      else if (res.status == 205) {
        this.service.hideSpinner();
        this.service.toasterErr(res.message)
      }
    }, err => {
      this.service.hideSpinner();
      if (err['status'] == '401') {
        this.service.onLogout();
        this.service.toasterErr('Unauthorized Access');
      } else {
        this.service.toasterErr(err.error.message);
      }
    })
  }



  perm_obj = {
    'USER_MANAGEMENT': [],
    'TOKEN_TRANS_MANAGEMENT': [],
    'TRANSACTION_MANAGEMENT': [],
    'PAYMENT_MANAGEMENT': [],
    'KYC_MANAGEMENT': [],
    'QUERY_MANAGEMENT': [],
    'STATIC_CONTENT_MANGEMENT': [],
    'TOKEN_MANAGEMENT': [],
    'FIERES_TUTORIAL': [],
    'CLAIM_TOKEN_MANAGEMENT': [],
    'VESTING_MANAGEMENT': []
  }
  updatePermission(isChecked, managementName, type) {


    let arr = this.perm_obj[managementName]

    if (isChecked) {
      arr.push(type)
      console.log(type);

      this.perm_obj[managementName] = arr
    } else {
      arr.splice(this.perm_obj[managementName].indexOf(type), 1)
      this.perm_obj[managementName] = arr
    }
    console.log(this.perm_obj);

  }

}
